import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { backButton } from '@telegram-apps/sdk-react';
import i18n from 'i18next';

import BanShape from '@/components/common/svg/shapes/BanShape.tsx';
import SupportShape from '@/components/common/svg/shapes/SupportShape.tsx';
import {
  buttonShapeStyles,
  buttonStyles,
  containerStyles,
  contentHeaderStyles,
  contentMessageStyles,
  contentShapeStyles,
  contentStyles
} from '@/components/Verification/styles.ts';

const BannedProfile = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const lang = searchParams.get('lang');

    if (lang && i18n.language !== lang) {
      void i18n.changeLanguage(lang);
    }

    if (backButton.isVisible()) {
      backButton.hide();
    }
  }, []);

  return (
    <div style={containerStyles}>
      <div style={contentStyles}>
        <BanShape
          width={70}
          height={70}
          fillColor="#b4b6bc"
          style={contentShapeStyles}
        />
        <span style={contentHeaderStyles}>{t('banned.page.header')}</span>
        <p style={contentMessageStyles}>{t('banned.page.message')}</p>
      </div>

      <motion.div whileTap={{ scale: 0.9 }} style={buttonStyles()}>
        <span>{t('banned.page.button')}</span>
        <SupportShape
          width={22}
          height={22}
          fillColor="#FFF"
          style={buttonShapeStyles}
        />
      </motion.div>
    </div>
  );
};

export default BannedProfile;
